/** Central TanStack Query key factory, so invalidation is never guesswork. */
export const queryKeys = {
  settings: ['settings'] as const,
  health: ['health'] as const,
  analyses: (params?: object) => ['analyses', params ?? {}] as const,
  analysis: (id: string) => ['analysis', id] as const,
  progress: (id: string) => ['analysis', id, 'progress'] as const,
  screenshots: (id: string) => ['analysis', id, 'screenshots'] as const,
  pages: (id: string) => ['analysis', id, 'pages'] as const,
  styles: (id: string) => ['analysis', id, 'styles'] as const,
  components: (id: string) => ['analysis', id, 'components'] as const,
  designDocument: (id: string) => ['analysis', id, 'design-md'] as const,
  projects: ['projects'] as const,
  project: (id: string) => ['project', id] as const,
};
